import React 				from 'react';
import PropTypes 			from 'prop-types';
import BLComponent			from '../core/_BLComponent.jsx';

import SimpleProductCard 	from '../common/_SimpleProductCard.jsx';
import {ColorWheel}			from '../common/_Icons.jsx';
import HiddenScroll			from '../common/_HiddenScroll.jsx';
import MultilineEllipsis from '../common/_MultilineEllipsis.jsx';


//this.props.classes	: string of classes

/*this.props.data 		: {
	  image: string of image url
	, name: string of product name
	, link: string of link
	, colorCount: int of color count
}*/

export default class PartColorCard extends BLComponent 
{
	constructor( props ) 
	{
		super(props);

		this.state = 
			{
				colorStatus: 		0
			,	colorError:			""
			,	colorItems:			null
			,	wantedListEnabled:	( props.wantedList && props.wantedList.enabled )
			,	qtyCheckEnabled: 	( props.qtyCheckEnabled )
			,	isWanted:			( props.wantedList && props.wantedList.isWanted )
			,	wantedCnt:			( props.wantedList && props.wantedList.wantedCount ) ? props.wantedList.wantedCount : 0
			,	limitedAvailable:	false
			};

		this.partsLink				= blapp.url2.getCatalogBrowseUrl( "P:" );
		this._callbackRegistered	= null;
	}

	static getDerivedStateFromProps( nextProps, prevState ) 
	{
		prevState.wantedListEnabled	= ( nextProps.wantedList && nextProps.wantedList.enabled );
		prevState.qtyCheckEnabled	= nextProps.qtyCheckEnabled;
		prevState.limitedAvailable	= nextProps.limitedAvailable == true ? true : false;

		return prevState;
	}

	componentDidMount() 
	{
		this.fetchPersonalizeData();
	}

	componentWillUnmount() 
	{ 
		super.componentWillUnmount(); 
		if ( this._callbackRegistered != null )
			blapp.personalized.unregisterCallback( this._callbackRegistered );
	}	

	componentDidUpdate( prevProps, prevState ) 
	{
		if ( ( prevState.wantedListEnabled != this.state.wantedListEnabled
				|| prevState.qtyCheckEnabled != this.state.qtyCheckEnabled
				|| prevProps.data.idItem != this.props.data.idItem
				|| prevProps.data.idColor != this.props.data.idColor )
			&& ( this.state.wantedListEnabled || this.state.qtyCheckEnabled ) )
		{
			blapp.personalized.fetchWantedPrefData( this.props.data.idItem, this.props.data.idColor, this.updatePersonalizedData );
		}

		if ( prevProps.overrideDrawer != this.props.overrideDrawer && prevState.colorStatus != 0 ) 
		{
			this.setState({colorStatus: 0, active: false});
		}
	}

	render() 
	{
		const 	{classes = '', inlineChildren} = this.props;
		const 	{link, image, name, itemNo, colorCnt} = this.props.data;
		const	cInfo	= blapp.color.get( this.props.data.idColorShown );

		const wantedListIsWanted 	= this.state.isWanted;
		const wantedListCount 		= this.state.wantedCnt;

		return (
			<article className={"card part-color-card " + classes + (this.state.colorStatus > 0 ? ' part-color-card--active' : '')}>
				<div className="card__internal product-card part-color-card__internal">
					<a href={link} className="product-card__main">
						<div className="product-card__image">
							<div className="product-card__image-internal">
								<img className="product-card__image-item" src={image}/>
							</div>
						</div>
					</a>
					<div className="part-color-card__title" title={name}>
						<MultilineEllipsis lines={2}>{name}</MultilineEllipsis>
					</div>
					<div>{itemNo}</div>
					<div className="product-card__meta">
						<div className="product-card__action product-card__wanted-list">
							<button className="l-cursor-pointer text--no-wrap" onClick={() => this.toggleAddWantedList()}>
								<i className={"product-card__wanted-icon l-margin-right--xxs " + (wantedListIsWanted ? "fas fa-heart" : "far fa-heart") + (wantedListIsWanted ? " product-card__wanted-icon--active" : "")}></i>
								{wantedListCount}
							</button>
						</div>
						{colorCnt > 1 ?
							<button className="btn btn--blank part-color-card-search__color-count" onClick={() => this.toggleColors()}>
								<ColorWheel classes="l-margin-right--sm"/>{colorCnt}<i className={"l-margin-left--sm fas fa-fw " + (this.state.active ? 'fa-chevron-up' : 'fa-chevron-down')}/>
							</button>
						:
							<div className="l-margin-left--sm overflow-ellipsis">{cInfo ? cInfo.strColorName : ""}</div>
						}
					</div>
				</div>
				<div className="part-color-card__children">
					<div className="mdc-layout-grid part-color-card__children-internal">
						<div className="part-color-card__children-internal-content">
							<header className="l-flex l-split l-center part-color-card__children-title">
								<h3 className=" text--small-title">{name} ({colorCnt})</h3>
								<button className="btn btn--blank l-margin-left text--title" onClick={() => this.toggleColors()}><i className="far fa-times"/></button>
							</header>
							{!inlineChildren ? 
								<div className="mdc-layout-grid__inner">
									{this.state.active && this.renderColors()}
								</div>
							:
								<HiddenScroll>
									{this.renderColors()}
								</HiddenScroll>
							}
						</div>
					</div>
				</div>
			</article>
		);
	}

	renderColors()
	{
		const cardClass = this.props.inlineChildren ? `part-color-card__inline-card` : `catalog-category-card__child mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-desktop-l mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone`;

		if ( this.state.colorStatus == 1 )
		{
			return	(
				<div className="l-pad l-full-width text--center text-color--white">Loading...</div>
			);
		}
		else if ( this.state.colorStatus == -1 )
		{
			return	(
				<div className="l-pad l-full-width text--center text-color--white">Error: {this.state.colorError}</div>
			);
		}
		else if ( this.state.colorStatus == 2 )
		{
			return	this.state.colorItems.map( ( ci, idx ) => <SimpleProductCard classes={cardClass} key={idx} item={ci}/> );
		}
	}

	fetchPersonalizeData()
	{
		if ( ( this.state.wantedListEnabled || this.state.qtyCheckEnabled ) && this.props.data.idItem )
		{
			this._callbackRegistered	= this.updatePersonalizedData;
			blapp.personalized.fetchPersonalizedData( this.props.data.idItem, this.props.data.idColor, this.updatePersonalizedData, this.state.wantedListEnabled, this.state.qtyCheckEnabled );
		}
	}	

	toggleAddWantedList = () =>
	{
		if ( this.state.wantedListEnabled )
		{
			const	srcMap 	= 	_.assign( 
									{ location: blapp.srcmap.LOCATION.GENERAL_XP, typeSrcFrom: blapp.srcmap.SRCTYPE.CATALOG_ITEM, idSrcFrom: this.props.wantedList.dmItemView.dmItem.idItem }
								,	this.props.wantedList && this.props.wantedList.srcMap ? this.props.wantedList.srcMap : {}
								);

			blapp.wanted.showAddWantedListModal
			(
				this.props.wantedList.dmItemView
			,	() => { this.fetchPersonalizeData(); }
			,	srcMap
			);
		}
	}	

	toggleColors()
	{
		this.setState({active: !this.state.active});

		if ( this.state.colorStatus > 0 )
		{
			this.setState( { colorStatus: 0 } );
		}
		else
		{
			if ( this.state.colorItems == null )
			{
				blapp.models.fetch(
					"_itemEx" + this.props.data.idItem
				,	{
						controller:		"catalog.BLCCatalogItem"
					,	method:			"getExtended"
					,	params:			[ this.props.data.idItem ]
					}
				).then(
					( data ) =>
					{
						let colorItems	= [];
						let	filter		= null;

						if ( this.state.colorStatus == 0 )
							return;						

						if ( !_.isEmpty( this.props.colorFilter ) )
						{
							filter	= {};
							_.forEach( this.props.colorFilter, ( c ) => { filter[ c ] = true; } );
						}						

						if ( data.mapColorVerified )
						{
							_.forEach(
								data.mapColorVerified
							,	( v, idColor ) =>
								{
									idColor	= parseInt( idColor );

									if ( filter != null && !filter[ idColor ] )
										return;

									const	ci	= blapp.color.get( idColor );

									if ( ci )
									{
										let	img	= data.mapColorImgs ? data.mapColorImgs[ idColor ] : null;

										if ( img == null )
										{
											img					= _.clone( data.dmBasic.imgDefault );
											img.idColor			= idColor;
											img.bNotAvailable	= true;
										}

										colorItems.push(
											{
												id:			idColor
											,	name:		ci.strColorName
											,	image:		blapp.url2.getCatalogItemImgUrl( img, "T2" )
											,	link:		blapp.url2.getCatalogItemPageUrl( data.dmBasic, idColor )
											}
										);
									}
								}
							)

							colorItems.sort( ( l, r ) => l.name.localeCompare( r.name ) );
						}
						else
						{
							const	ci			= blapp.color.get( data.dmBasic.idColorDefault );

							if ( ci )
							{
								colorItems.push(
									{
										id:			ci.idColor
									,	name:		ci.strColorName
									,	image:		blapp.url2.getCatalogItemImgUrl( data.dmBasic.imgDefault, "T2" )
									,	link:		blapp.url2.getCatalogItemPageUrl( data.dmBasic, ci.idColor )
									}
								);								
							}
						}
						
						if ( _.isEmpty( colorItems ) )
							this.setState( { colorStatus: -1, colorError: "Color information not available." } );
						else
							this.setState( { colorStatus: 2, colorItems: colorItems } );
					}
				).catch( 
					( err ) =>
					{
						if ( this.state.colorStatus > 0 )
							this.setState( { colorStatus: -1, colorError: err } );
					}
				);


				this.setState( { colorStatus: 1 } );
			}
			else
			{
				this.setState( { colorStatus: 2 } );
			}
		}
		if(this.props.drawerFunction) {
			this.props.drawerFunction();
		}
	}

	updatePersonalizedData = ( data ) => 
	{
		if ( data && data.dataWantedPref )
		{
			this.setState( { isWanted: data.dataWantedPref.bIsWanted, wantedCnt: data.dataWantedPref.nWantedUserCnt } );
		}

		if ( data && data.dataRemainQty )
		{
			this.setState( { limitedAvailable: ( data.dataRemainQty.nRemainQtyIC > 0 && data.dataRemainQty.nRemainQtyIC <= 5 ) ? true : false } );
		}
	}	
	

	static getDataFromBLMCatalogItemWithColor( item, imgSize )
	{
		return	{
					image:			blapp.url2.getCatalogItemImgUrl( item.dmImg, imgSize )
				,	name:			item.dmItem.strItemName
				,	itemNo:			item.dmItem.strItemNoFull
				,	link:			blapp.url2.getCatalogItemPageUrl(item.dmItem, item.idColor)
				,	idItem:			item.dmItem.idItem
				,	idColor:		item.idColor
				,	colorCnt:		item.nMatchedColorCnt
				,	idColorShown:	( item.dmImg ? item.dmImg.idColor : item.idColor )
				}
	}

	static getWantedListEnableInfo( dmItemView, srcMap )
	{
		return 	{
					enabled: 		true
				,	isWanted:		false
				,	wantedCount: 	0
				,	dmItemView:		dmItemView
				,	srcMap:			srcMap
				};
	}	
}

PartColorCard.propTypes = 
	{
		classes:			PropTypes.string
	,	data: 				PropTypes.shape(
								{
					  				image:			PropTypes.string.isRequired
								,	name:			PropTypes.string.isRequired
								,	link:			PropTypes.string.isRequired
								,	idItem:			PropTypes.number
								,	idColor:		PropTypes.number
								,	colorCnt:		PropTypes.number
								,	idColorShown:	PropTypes.number
								}
							).isRequired
	,	colorFilter:		PropTypes.array
	,	wantedList:			PropTypes.shape(
								{
									enabled:		PropTypes.bool
								,	isWanted:		PropTypes.bool
								,	wantedCount:	PropTypes.number
								,	dmItemView:		PropTypes.object
								,	srcMap:			PropTypes.object
								}
							)
	,	qtyCheckEnabled:	PropTypes.bool
	,	limitedAvailable:	PropTypes.bool
	,	overrideDrawer:		PropTypes.bool
	,	drawerFunction:		PropTypes.func	
	}